<template>
    <div
        id="sidebar"
        v-click-outside="away"
        :class="sidebarOpen ? 'opened' : 'closed'"
    >
        <div class="btn-menu">
            <a class @click="toggleSidebar()">
                <i class="fa fa-2x fa-bars"></i>
            </a>
        </div>
        <ul id="nav">
            <router-link to="/" @click.native="away" class="logo">
                <img src="../assets/logo.png" />
            </router-link>
            <div class="user">
                <div
                    class="user-detail"
                    :class="$socket.connected ? 'online' : 'offline'"
                >
                    <p class="name">{{ user.name }}</p>
                    <p class="entitle">{{ user.job }}</p>
                </div>
                <div class="user-bar">
                    <a
                        class="user-settings btn link-cyan"
                        @click="editPassword()"
                    >
                        <i class="fa fa-lg fa-cog"></i> Ayarlar
                    </a>
                    <a class="user-logout btn link-red" @click="logout()">
                        <i class="fa fa-lg fa-window-close"></i> Çıkış
                    </a>
                </div>
                <div class="modal-overlay" v-if="editingPassword">
                    <div class="modal-box small">
                        <span class="close" @click="cancelPassword()"
                            >&times;</span
                        >
                        <h3>Ayarlar</h3>

                        <form autocomplete="off" v-on:submit.prevent>
                            <div class="labeledit">
                                <label for="p-old">Eski Şifre</label>
                                <input
                                    type="password"
                                    id="p-old"
                                    v-model="pwd.old"
                                    placeholder="Eski Şifre"
                                />
                            </div>
                            <div class="labeledit">
                                <label for="p-new">Yeni Şifre</label>
                                <input
                                    type="password"
                                    v-model="pwd.new"
                                    id="p-new"
                                    placeholder="Yeni Şifre"
                                />
                            </div>
                            <div class="labeledit">
                                <label for="p-newt">Yeni Şifre (Tekrar)</label>
                                <input
                                    type="password"
                                    v-model="pwd.newt"
                                    id="p-newt"
                                    placeholder="Yeni Şifre (tekrar)"
                                />
                            </div>
                        </form>
                        <div class="button-bar">
                            <a
                                class="btn link-green fr"
                                @click.prevent="savePassword()"
                            >
                                <i class="fa fa fa-save"></i> Kaydet
                            </a>
                            <div class="clear"></div>
                        </div>
                    </div>
                </div>
            </div>

            <li>
                <router-link
                    to="/"
                    @click.native="away"
                    active-class="active"
                    class="menu"
                    :class="{
                        'router-link-active': isAnaMenu(),
                    }"
                >
                    <i class="fa fa-lg fa-home"></i>Ana Sayfa
                </router-link>
            </li>
            <span class="title c-green">Yeni Yatış</span>
            <li>
                <router-link to="/yeniyd" @click.native="away" class="menu">
                    <i class="fa fa-lg fa-plus"></i>Yenidoğan
                </router-link>
            </li>
            <li>
                <router-link to="/yeniservis" @click.native="away" class="menu">
                    <i class="fa fa-lg fa-plus"></i>Servis & Yoğun Bakım
                </router-link>
            </li>
            <span class="title">Uygulamalar</span>

            <li>
                <router-link
                    to="/patients/yogunbakim"
                    @click.native="away"
                    class="menu"
                >
                    <i class="fa fa-lg fa-baby"></i>Yenidoğan & Yoğun Bakım
                </router-link>
                <ul class="submenu">
                    <li>
                        <router-link
                            to="/birthlist"
                            @click.native="away"
                            class="menu"
                        >
                            <i class="fa fa-lg fa-clipboard-list"></i>Doğum
                            Listesi
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/vizitlist"
                            @click.native="away"
                            class="menu"
                        >
                            <i class="fa fa-lg fa-clipboard-list"></i>KHD Vizit
                            Listesi
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/tcb"
                            @click.native="away"
                            class="menu"
                        >
                            <i class="fa fa-lg fa-caret-right"></i>Hasta Takibi
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/deviryd"
                            @click.native="away"
                            class="menu"
                        >
                            <i class="fa fa-lg fa-caret-right"></i>Devir Notu
                        </router-link>
                    </li>
                </ul>
            </li>
            <li>
                <router-link
                    @click.native="away"
                    to="/patients/servis"
                    class="menu"
                >
                    <i class="fa fa-lg fa-child"></i>Servis
                </router-link>
            </li>
            <ul class="submenu">
                <li>
                    <router-link to="/devir" @click.native="away" class="menu">
                        <i class="fa fa-lg fa-caret-right"></i>Devir Notu
                    </router-link>
                </li>
            </ul>

            <span class="title">DİYABETİK KETOASİDOZ</span>

            <li>
                <router-link @click.native="away" to="/ketoasidoz" class="menu">
                    <i class="fa fa-lg fa-medkit"></i>Diyabetik Ketoasidoz
                </router-link>
            </li>

            <span class="title">ARŞİV</span>

            <li>
                <router-link @click.native="away" to="/arsiv" class="menu">
                    <i class="fa fa-lg fa-archive"></i>Taburcu Listesi
                </router-link>
            </li>
            <span class="title">EĞİTİM</span>

            <li>
                <router-link @click.native="away" to="/documents" class="menu">
                    <i class="fa fa-lg fa-info"></i>Dökümanlar
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import qs from "qs";

export default {
    name: "Sidebar",
    data() {
        return {
            editingPassword: false,
            pwd: {
                old: "",
                new: "",
                newt: "",
            },
        };
    },
    computed: {
        sidebarOpen() {
            return this.$store.getters.getSidebar;
        },
        user() {
            return this.$store.getters.getUser;
        },
        pusherStatus() {
            return this.$store.getters.getPusherStatus;
        },
        activeMenu() {
            return this.$store.getters.getActiveMenu;
        },
    },
    methods: {
        isAnaMenu() {
            if (this.$route.name == "Dashboard") {
                return true;
            } else {
                return false;
            }
        },
        savePassword() {
            let self = this;
            if (this.pwd.new != this.pwd.newt || this.pwd.new == "") {
                self.$snotify.error(
                    "Yeni şifre boş olmamalı ve birbiri ile aynı olması gerekmektedir"
                );
                this.pwd = {
                    new: "",
                    newt: "",
                };
            } else {
                this.$http({
                    method: "post",
                    url: "api/password.php",
                    data: qs.stringify(this.pwd),
                }).then(function(response) {
                    switch (response.data.result) {
                        case 200:
                            self.$snotify.success(
                                "Şifreniz başarıyla değiştirildi"
                            );
                            self.editingPassword = false;
                            break;
                        case 404:
                            self.$snotify.error(
                                "Eski şifrenizi yanlış girdiniz"
                            );
                            break;
                    }
                    self.pwd = {
                        old: "",
                        new: "",
                        newt: "",
                    };
                });
            }
        },
        cancelPassword() {
            this.editingPassword = false;
            this.pwd = {
                old: "",
                new: "",
                newt: "",
            };
        },
        editPassword() {
            this.editingPassword = !this.editingPassword;
        },
        toggleSidebar() {
            this.$store.dispatch("toggleSidebar", !this.sidebarOpen);
        },
        away: function() {
            if (this.sidebarOpen) {
                this.$store.dispatch("toggleSidebar", false);
            }
        },
        logout() {
            let self = this;
            this.$http({
                method: "post",
                url: "api/logout.php",
                data: qs.stringify({}),
            })
                .then((request) => {
                    if (request.data.logout) {
                        self.$store.dispatch("logoutUser");
                        self.$router.push("/login");
                    }
                })
                .catch((error) => {
                    self.$snotify.error("Çıkış yapılamadı : " + error);
                });
        },
    },
    created() {
        /* let self = this;
        this.$http.get("api/dash.php").then(function (response) {
            self.$store.dispatch("getDash", response.data);
        }); */
    },
};
</script>

<style lang="scss">
.btn-menu {
    position: absolute;
    display: none;
    top: 0;
    color: white;
    right: 0;
    z-index: 100;
    background: $sidebar;
    a {
        display: block;
        padding: 10px 12px;
        width: 45px;
    }
}
#sidebar {
    color: $text;
    width: 230px;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: $sidebar;
    &:after {
        content: "";
        display: none;
        background: $sidebar;
        position: absolute;
        top: -10px;
        right: -10px;
        width: 20px;
        height: 20px;
        border-radius: 10px;
    }
    a.logo {
        margin: 0;
        display: block;
        padding: 0;
        height: 45px;
        background-color: $sidebar !important;
        border: 0 !important;
        img {
            height: 45px;
        }
    }
    .ps {
        height: 100%;
    }
}

#nav {
    position: relative;
    overflow: hidden;
    top: 0;
    bottom: 0;
    div.user {
        margin: 10px;
        border-radius: 10px;
        border: 1px solid $sidebarLight;
        background-color: $sidebar;
        position: relative;
        background-color: darken($sidebar, 2);

        .user-detail {
            text-align: center;
            padding: 6px;
            width: 100%;
            display: block;
            p.name {
                padding: 6px 0;
                color: white;
                font-size: 14px;
            }
            p.entitle {
                padding: 6px 0;
                color: $text;
                font-size: 13px;
            }
            &.online {
                border-bottom: 1px solid $green !important;
            }
            &.offline {
                border-bottom: 1px solid $sidebarLight !important;
            }
        }
    }
    .user-bar {
        display: flex;
        svg {
            margin: 0 3px;
        }
        a {
            text-align: center;
            flex: 1 1 50%;
            padding: 10px;
            margin: 0;
            &:hover {
                background-color: $sidebarLight;
            }
            &:first-child {
                border-bottom-left-radius: 8px;
            }
            &:last-child {
                border-bottom-right-radius: 8px;
            }
        }
    }
    .t-password {
        border-top: 1px solid $alphaDivider;
        border-bottom: 1px solid $alphaDivider;
        padding: 10px 5px;
        input {
            width: 100%;
            margin: 2px 0;
        }
        .button-bar {
            text-align: center;
        }
    }
    span.title {
        padding: 4px 8px;
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 2px;
        margin: 5px 0;
        display: block;
        font-weight: 700;
        color: $text;
        letter-spacing: -0.1px !important;
    }
    a.menu {
        display: block;
        box-sizing: border-box;
        padding: 8px 5px;
        font-weight: 500;
        width: 100%;
        color: white;
        border-left: 4px solid transparent;
        &:hover {
            background-color: $primary;
            color: white;
        }
        svg {
            display: inline-block;
            width: 24px;
            margin-right: 2px;
        }
    }
    .submenu {
        a {
            font-weight: 400;
            color: $gray-400;
            padding: 6px 6px 6px 16px !important;
            background-color: darken($sidebar, 2);
            &:hover {
                background-color: lighten($primary, 5);
            }
        }
    }
    a.router-link-active {
        color: white;
        background-color: $sidebarSelected;
        border-left: 4px solid $primary;
    }
}

@media (max-width: 1280px) {
    #sidebar {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;

        //transform-origin: center left; /* Set the transformed position of sidebar to center left side. */
        // left: -250px;
        overflow: hidden;
        &.opened {
            max-height: 700px;
            transition: max-height 0.25s ease-out;
        }
        &.closed {
            max-height: 45px;
            transition: max-height 0.4s ease-in;
        }
    }
    .btn-menu {
        display: block;
    }
}
</style>
